import clsx from 'clsx';

type ClassifyTagProps = {
  children: React.ReactNode;
  className?: string;
};

export default function ClassifyTag({ children, className }: ClassifyTagProps) {
  return (
    <div className={clsx('flex items-center bg-light-primary-14 px-[8px] py-[2px] text-light-primary', className)}>
      <i className="iconfont icon-shining-fill mr-[4px] text-light-primary"></i>
      {children}
    </div>
  );
}
